import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const DOTS = '...';

const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};

const GriddlePagingRP = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;
    const totalPageCount = Math.ceil(totalCount / pageSize);

    // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
    const totalPageNumbers = siblingCount + 5;

    /*
    	Calculate left and right sibling index and make sure they are within range 1 and totalPageCount
    */
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
        currentPage + siblingCount,
        totalPageCount
    );

    let paginationRange = [];
    /*
      We do not show dots just when there is just one page number to be inserted between the extremes of sibling and the page limits i.e 1 and totalPageCount. Hence we are using leftSiblingIndex > 2 and rightSiblingIndex < totalPageCount - 2
    */
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 1;

    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;

    let leftRange = [];
    let middleRange = [];
    let rightRange = [];
    /*
        Case 1:
        If the number of pages is less than the page numbers we want to show in our
        paginationComponent, we return the range [1..totalPageCount]
        */
    if (totalPageNumbers >= totalPageCount) {
        paginationRange = range(1, totalPageCount);
    }

    /*
    	Case 2: No left dots to show, but rights dots to be shown
    */
    if (!shouldShowLeftDots && shouldShowRightDots) {
        leftRange = range(1, 4);

        paginationRange = [...leftRange, DOTS];
    }

    /*
    	Case 3: No right dots to show, but left dots to be shown
    */
    if (shouldShowLeftDots && !shouldShowRightDots) {
        rightRange = range(
            totalPageCount - 3,
            totalPageCount
        );
        paginationRange = [DOTS, ...rightRange];
    }

    /*
    	Case 4: Both left and right dots to be shown
    */
    if (shouldShowLeftDots && shouldShowRightDots) {
        middleRange = range(leftSiblingIndex, rightSiblingIndex);
        paginationRange = [DOTS, ...middleRange, DOTS];
    }

    return (
        <div
            className={`pager ui-content ui-btnGroup ui-btnGroup_pagination ${className}`}
        >
            <div
                className={'pager-total_count'}
            ><b>{totalCount}</b>  Stallions found
            </div>
            <div className={'pager__controls'}>
                {currentPage !== firstPageIndex ?
                    <div
                        onClick={() => onPageChange(firstPageIndex)}
                        className={'pager-control__left ui-btn'}
                    >
                        <Svg size={'Small'} iconName={'left'} />
                    </div> : null}

                {paginationRange.map(pageNumber => {
                    if (pageNumber === DOTS) {
                        return <div className="pagination-item pager_dots">&#8230;</div>;
                    }

                    return (
                        <div
                            className={`ui-btn_paginationItem${currentPage === pageNumber ? '__selected' : ''} ui-btn`}
                            key={pageNumber}
                            data-value={pageNumber}
                            onClick={() => onPageChange(pageNumber)}
                        >{pageNumber}
                        </div>
                    );
                })}
                {currentPage !== lastPageIndex ?
                    <div
                        onClick={() => onPageChange(lastPageIndex)}
                        className={'pager-control__left ui-btn'}
                    >
                        <Svg size={'Small'} iconName={'right'} />
                    </div> : null
                }
            </div>
        </div>
    );
};

GriddlePagingRP.propTypes = {
    className: PropTypes.string,
    currentPage: PropTypes.number,
    totalCount: PropTypes.number,
    pageSize: PropTypes.number,
    siblingCount: PropTypes.number,
    onPageChange: PropTypes.func,
};

GriddlePagingRP.defaultProps = {
    currentPage: 0,
    pageSize: 36,
    siblingCount: 1
};

export default GriddlePagingRP;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/Pagination.js